import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 border-t border-zinc-900 text-center text-zinc-600 text-sm" data-id="element-85">
      <p className="mb-2" data-id="element-86">
        © {new Date().getFullYear()} Entrena en Casa™. Todos los derechos
        reservados.
      </p>
      <p className="text-xs max-w-2xl mx-auto" data-id="element-87">
        Este sitio no es parte del sitio web de Facebook o Facebook Inc. Además,
        este sitio NO está respaldado por Facebook de ninguna manera. FACEBOOK
        es una marca registrada de FACEBOOK, Inc. Los resultados pueden variar
        de persona a persona.
      </p>
    </footer>;
}